<template>
  <div class="q-nps-container main-color">
      <label v-html="question.q" class="q-label"></label>
    <div class="q-nps-label">
      <label class="nps_label">{{question.begin_text}}</label>
      <label class="nps_label" style="text-align:right;">{{question.end_text}}</label>
    </div>
    <div style="width:100%; display:flex; flex-direction:row;">
      <label ref="options" v-for="option in question.answers" :key="option.value" :value="option.value" style="width:100%;" class="label_nps" v-on:click="selectNPS">{{ option.value }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "nps-question",
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
    answerProp:{
      type: String,
      default: ""
    }
  },
  data: function() {
    return {
      answer: ""
    };
  },
  computed: {
    myComputedWidth() {
      return Math.round(100 / ((this.question.max - this.question.min)+1));
    }
  },
  methods: {
    selectNPS: function(event) {
     
      //put to all elements the same class
      var x = this.$refs.options;//document.getElementsByClassName("label_nps_selected");
      for (var i = 0; i < x.length; i++) {
        x[i].className = "label_nps";
      }

      //set the selected document
      event.target.classList.remove("label_nps");
      event.target.classList.add("label_nps_selected");
      this.answer = event.target.innerText;
      //console.log(event.target.innerText);
      //console.log(event.target);
      //console.log("La respuesta es: " + this.answer);
      this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": this.answer });
    },
    selectNPSValue: function(value) {
     
      //put to all elements the same class
      var x = this.$refs.options;//document.getElementsByClassName("label_nps_selected");
      for (var i = 0; i < x.length; i++) {
        if(x[i].innerText === value){
          x[i].className = "label_nps_selected";
        }
        else{
          x[i].className = "label_nps";
        }
        
      }
    }
  },
  mounted: function() {
    if(this.answerProp != ""){
      this.selectNPSValue(this.answerProp);
    }
  }
};
</script>

<style lang="scss" scoped>
  .label_nps{
    text-align: center;
    float: left;
    font-size: 0.9em;
    height: auto;
    margin: 0;
    /* padding: 10px; */
    padding-top:10px;
    padding-right:4px;
    padding-bottom:10px;
    padding-left:4px;
    -moz-border-radius: 5px;
    /* -webkit-border-radius: 5px; */
    /* border-radius: 5px; */
}

.nps_label{
    font-size: small;
    color: #b1b1b1;
    font-style: italic;
    margin:0px;
    display: inline-block;
    padding: 0;
    width: 50%;
}

.label_nps_selected{
       text-align: center;
    float: left;
    font-size: 0.9em;
    height: auto;
    margin: 0;
    /* padding: 10px; */
    padding-top:10px;
    padding-right:4px;
    padding-bottom:10px;
    padding-left:4px;
    -moz-border-radius: 5px;
    /* -webkit-border-radius: 5px; */
    /* border-radius: 5px; */
}
</style>
